<template>
  <v-form>
    <!-- コミュニケーション品目 -->
    <v-container>
      <v-card class="parkingSelect" false>
        <v-row>
          <v-col cols="4" class="headerTitle">
            <ryou-select
              class="bukens"
              :items="dynamicItems"
              :itemText="'building_name'"
              :label="'物件名'"
              :itemValue="'building_id'"
              v-model="selectBuild"
              :value="selectBuild"
            >
            </ryou-select>
          </v-col>
          <v-col cols="3" class="headerTitle">
            <ryou-date-format
              ref="ryou_frdate_format"
              v-model="selFromDate"
              :value="selFromDate"
              :type="'date'"
              :format="'$1/$2/$3'"
              :label="'出力期間'"
              :rules="indateRules"
              :max="selectMax"
            >
            </ryou-date-format>
          </v-col>
          <v-col cols="3" class="headerTitle">
            <ryou-date-format
              ref="ryou_todate_format"
              v-model="selToDate"
              :value="selToDate"
              :type="'date'"
              :format="'$1/$2/$3'"
              :label="'出力期間'"
              :rules="indateRules"
              :min="selectMin"
            >
            </ryou-date-format>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="risuto" outlined>
        <!-- 2024.11.29 kouta.noborisaka 三井化学（市原工場）:絞り込みでEnterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
        <v-form
          ref="tableForm"
          v-model="tableForm"
          lazy-validation
          @submit.prevent
        >
          <ryou-table
            ref="ryouTable"
            :rowKey="rowKey"
            :headers="headers"
            :needSearch="true"
            :dummy="false"
            :url="url"
            :height="650"
            :businessKey="businessKey"
            :queryParams="queryParams"
            :showSelect="true"
          >
            <v-row slot="filterContainer"> </v-row>
          </ryou-table>
        </v-form>
        <v-card-actions>
          <ryou-black-btn
            :label="'ファイル出力'"
            :handlerClick="downloadExcel"
            :iconCls="'mdi-file-download'"
          >
          </ryou-black-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-form>
</template>

<script>
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
import fileDownload from "js-file-download";
export default {
  name: "SalaryCommunicationItem",
  mixins: [RyouTableMixins],
  components: {
    RyouSelect,
    RyouTable,
    RyouBlackBtn,
    RyouDateFormat,
  },
  mounted() {
    this.$refs.ryouTable.$on("getSelectedRowKeys", this.getSelectedRowKeys);
  },
  data() {
    return {
      tableForm: true,
      rowKey: "rowIndex",
      selectBuild: "",
      dynamicItems: [],
      selected: [], //チェックボックス選択の項目データ
      indateRules: [],
      searchUserId: "",
      selFromDate: "",
      selToDate: "",
      selectMin: "",
      selectMax: "",
      businessKey: "building_id",
      headers: [
        {
          text: "利用日時",
          class: "blue lighten-2 title",
          value: "b_date",
          align: "center",
          width: "12%",
          groupable: false,
        },
        {
          text: "利用者区分",
          class: "blue lighten-2 title",
          value: "pay_class",
          align: "center",
          width: "10%",
          groupable: false,
        },
        {
          text: "ユーザID",
          class: "blue lighten-2 title",
          value: "user_id",
          align: "center",
          width: "8%",
          groupable: false,
        },
        {
          text: "部屋番号",
          class: "blue lighten-2 title",
          value: "room_id",
          align: "center",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "ユーザ名",
          class: "blue lighten-2 title",
          value: "user_name",
          align: "center",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "分類",
          class: "blue lighten-2 title",
          value: "class_name",
          align: "center",
          width: "6%",
          sortable: true,
          groupable: false,
        },
        {
          text: "品目",
          class: "blue lighten-2 title",
          value: "menu_item_name",
          align: "center",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "数量",
          class: "blue lighten-2 title",
          value: "num",
          align: "center",
          width: "6%",
          sortable: true,
          groupable: false,
        },
        {
          text: "単価",
          class: "blue lighten-2 title",
          value: "unit_price",
          align: "center",
          width: "6%",
          sortable: true,
          groupable: false,
        },
        {
          text: "代金",
          class: "blue lighten-2 title",
          value: "total_fee",
          align: "center",
          width: "6%",
          sortable: true,
          groupable: false,
        },
        {
          text: "伝票No",
          class: "blue lighten-2 title",
          value: "slip_no",
          align: "center",
          width: "14%",
          sortable: true,
          groupable: false,
        },
        {
          text: "飲食店従業員ID",
          class: "blue lighten-2 title",
          value: "input_user_id",
          align: "center",
          width: "8%",
          sortable: true,
          groupable: false,
        },
      ],
      queryParams: {
        userId: this.$store.getters.getUserId,
        buildingId: "1",
        fromDate: "",
        toDate: "",
      },
      url: {
        list: "/salaryCommunication/crOrderListGet",
      },
      height: 800,
    };
  },
  created() {
    this.initData();
  },
  watch: {
    selectBuild() {
      this.callLoadData();
    },
    selFromDate() {
      this.callLoadData();
      this.selectMin = this.selFromDate;
    },
    selToDate() {
      this.callLoadData();
      this.selectMax = this.selToDate;
    },
  },
  methods: {
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/energyInput/buildingNameGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        //物件名取得
        if (data.success) {
          var mapDatas = data.result.map((item) => {
            item.building_id = String(item.building_id);
            return item;
          });
          this.dynamicItems = mapDatas;
          this.selectBuild = this.dynamicItems[0].building_id;
        }
      });

      // 初期値は前月1日から現在日付
      const dt = new Date();
      const toMonth = ("0" + (dt.getMonth() + 1)).slice(-2);
      const day = ("0" + dt.getDate()).slice(-2);
      this.selToDate = dt.getFullYear() + "-" + toMonth + "-" + day;

      dt.setMonth(dt.getMonth() - 1);
      const frMonth = ("0" + (dt.getMonth() + 1)).slice(-2);
      this.selFromDate = dt.getFullYear() + "-" + frMonth + "-01";
    },
    callLoadData() {
      if (this.selectBuild != "") {
        this.$refs.ryouTable.clearTable();
        this.queryParams.buildingId = this.selectBuild;
        this.queryParams.fromDate = this.selFromDate;
        this.queryParams.toDate = this.selToDate;
        this.$refs.ryouTable.loadData();

        this.$refs.ryou_frdate_format.initViewDate(this.selFromDate);
        this.$refs.ryou_todate_format.initViewDate(this.selToDate);
      }
    },
    downloadExcel() {
      //チェックボックス選択の項目データ取得
      this.selected = this.selectionRows;
      //CSV作成
      this.postRequest(
        "/salaryCommunication/itemCSVCreate",
        this.selected,
        this.$store.getters.getUserToken
      ).then((resp) => {
        //ファイルパスは戻り
        if (resp.success) {
          let streamParams = {
            filePath: resp.result,
          };

          //csvをダウンロード
          this.getStreamRequest(
            "/salaryCommunication/CSVGet",
            streamParams,
            this.$store.getters.getUserToken
          )
            .then((res) => {
              const blob = new Blob([res], {
                type: "application/octet-stream;charset=utf-8",
              });
              return fileDownload(
                blob,
                "コミュニケーション品目_" + this.getDateTime() + ".csv"
              );
            })
            .catch(function (error) {
              // console.log(error);
            });
        }
      });
    },

    getDateTime() {
      const year = new Date().getFullYear();
      const month =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      const date =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      const hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      const mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      const ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      const nowTime = year + month + date + hh + mm + ss;
      return nowTime;
    },
  },
};
</script>

<style scoped>
.detail {
  padding-top: 20px;
}

.headerTitle {
  padding-bottom: 0px;
}

.headerbtn {
  padding: 0px 12px;
  margin-bottom: 30px;
}

.buken {
  width: 150px;
  height: 60px;
  padding-top: 2%;
}

.bukens {
  width: 300px;
  height: 80px;
}

.buken,
.bukens {
  float: left;
  box-sizing: border-box;
}
</style>
